var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComparearrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 21",
    x: 1.60698,
    y: 45.4344,
    width: 43.8681,
    height: 45.9333,
    transform: "rotate(-90 1.60698 45.4344)",
    stroke: "#333333",
    strokeWidth: 2.6,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.8022 16.6138L35.9361 18.0312L30.4108 22.4514V25.6455H39.5471V32.9062H30.4108V38.4727L18.9771 29.2739L34.8022 16.6138Z",
    className: "secondary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7046 7.49525L29.1447 16.568L13.092 29.4102L11.958 27.9928L17.7046 23.3955V20.2014H8.56834L8.56834 12.9407L17.7046 12.9407L17.7046 7.49525Z",
    className: "primary"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparearrows);
export default __webpack_public_path__ + "static/media/comparearrows.e64e92509af6236aee6a4de1a27ea944.svg";
export { ForwardRef as ReactComponent };